// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__1cVYa","legacyBtn":"MutateMid_legacyBtn__3Xtpf"};